import React from "react";
import { Button } from "react-bootstrap";
import autoBind from "react-autobind";
import _ from "lodash";

class PlayerPickerButtons extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
	}

	onChange(value) {
		if (this.props.onChange) {
			this.props.onChange(value);
		}
	}

	render() {
		let self = this;
		let { options, disabled } = this.props;
		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;
		const pickerTheme = _.get(theme, "item.picker.buttons");

		let pickerItems = options.map(function (pickerItem) {
			if (pickerItem.properties && pickerItem.properties !== "") {
				let properties = pickerItem.properties;

				let propertiesObject = JSON.parse(properties);
				Object.assign(pickerItem, propertiesObject);
			}

			let style = _.assign({
				margin: 5,
				padding: 5,
				fontSize: 18,
				fontWeight: pickerItem.value === self.props.item.value ? "bold" : "normal",
				textAlign: "center",
				borderRadius: 10,
				borderStyle: "solid",
				borderWidth: 2,
				borderColor: pickerItem.value === self.props.item.value ? "blue" : "transparent",
				overflow: "hidden"
			}, pickerTheme);

			// style.borderColor;

			

			if (pickerItem.value === self.props.item.value) {
				_.keys(pickerTheme).forEach(key => {
					if (key.indexOf("selected") === 0) {
						const ccKey = _.camelCase(key.replace("selected", ""));
						style[ccKey] = pickerTheme[key];
					}
				});
			}

			if (pickerItem.style) {
				style = Object.assign(style, pickerItem.style);			
				
				//style.borderColor = style.color;
			}

			return <Button disabled={disabled} key={"key-" + pickerItem.value} style={{ ...style }}		 		
				onClick={() => {

					/*
					actions.handleChangeProperty(self.context.tree, self.props.listIndex, self.props.sectionIndex, self.props.itemIndex, "value", pickerItem.value);

					var linkOnSelect = (self.props.item.hasOwnProperty("pickerLinkOnSelect") ? self.props.item.pickerLinkOnSelect : false);
					var linkActionType = (self.props.item.hasOwnProperty("pickerLinkActionType") ? self.props.item.pickerLinkActionType : "goto");
					setTimeout(() => {
						actions.setItemPickerChecked(self.context.tree, self.props.listIndex, self.props.sectionIndex, self.props.itemIndex, linkOnSelect, linkActionType, true);
					})*/
					self.onChange(pickerItem.value);

				}}>				
				<span>{pickerItem.label}</span>
			</Button>;
		});

		let pickerButtons =
			<div style={{display: "flex", flexDirection: "column"}}>
				{pickerItems}
			</div>;
		
		return pickerButtons;
	}
}

export default PlayerPickerButtons;